import { useState, useEffect } from "react";

import MinimalPage from "../../layout/MinimalPage";
import Filtros from "./Filtros";
import Listado from "./Listado";
import api from "../../service/api";

const breadcrumbs = [
  { nombre: "Inicio", ruta: "/" },
  { nombre: "Consulta de grupos", ruta: "" },
];

const ConsultaGruposPage = ({ funcion }) => {
  const [grupos, setGrupos] = useState([]);

  const buscar = async (filtros) => {
    try {
      const response = await api.buscarGrupos(filtros);
      setGrupos(response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  const guardar = async (datos) => {
    try {
      const response = await api.guardarGrupo(datos);
      setGrupos([]);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  //   useEffect(() => {
  //     buscar();
  //   }, []);

  return (
    <MinimalPage breadcrumbs={breadcrumbs}>
      <Filtros buscar={buscar} />
      <Listado grupos={grupos} guardar={guardar} />
    </MinimalPage>
  );
};

export default ConsultaGruposPage;
